const business = {
  init () {
    this.getData();
  },
  getData () {
    console.log('=====> getData');
  },
};

export default business;
